import { Box, Chip } from "@mui/material";
import type { DevelopmentArea } from "../patterns.api";

/** Filters the explorer list by skill area; "All" clears it. */
export const SkillChips = ({
  areas,
  selected,
  onSelect,
}: {
  areas: DevelopmentArea[];
  selected: DevelopmentArea["key"] | null;
  onSelect: (key: DevelopmentArea["key"] | null) => void;
}) =>
  areas.length ? (
    <Box role="group" aria-label="Filter by skill" sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
      <Chip
        label="All"
        clickable
        color={selected === null ? "secondary" : "default"}
        variant={selected === null ? "filled" : "outlined"}
        aria-pressed={selected === null}
        onClick={() => onSelect(null)}
        sx={{ borderRadius: 0 }}
      />
      {areas.map((area) => (
        <Chip
          key={area.key}
          label={`${area.label} · ${area.affectedGames}`}
          clickable
          color={selected === area.key ? "secondary" : "default"}
          variant={selected === area.key ? "filled" : "outlined"}
          aria-pressed={selected === area.key}
          onClick={() => onSelect(area.key)}
          sx={{ borderRadius: 0 }}
        />
      ))}
    </Box>
  ) : null;
